const getters = {
  globalData: state => state.app.globalData,
  key: state => state.app.key,
  token: state => state.app.token,
  mapKey: state => state.app.mapKey,
  communityKey: state => state.app.communityKey,
  plotKey: state => state.app.plotKey,
  visitUsers: state => state.app.visitUsers,
  tapMapCount: state => state.app.tapMapCount,
  profile: state => state.login.profile,
  largeConfig: state => state.login.largeConfig,
  channelAccout: state => state.login.channelAccout
}
export default getters
